import { t as e } from "./buildSyncList-Bn1PFQeU.js";
import { useTransition as t } from "react";
import { useFormContext as n } from "react-hook-form";
//#region src/hooks/shared/useBuildSyncLists.ts
var r = () => {
	let { getValues: r, setValue: i } = n(), [, a] = t(), o = () => ({
		connections: r("collectorSettings.connections") || [],
		analyticsSettings: r("analyticsSettings"),
		syncDestinations: r("syncSettings.syncDestinations") || []
	}), s = () => {
		let { connections: t, analyticsSettings: n, syncDestinations: r } = o();
		r.forEach((r, a) => {
			let o = e({
				connections: t,
				analyticsSettings: n,
				destination: r
			});
			i(`syncSettings.syncDestinations.${a}.retentionMeasurementSyncInfo`, o, {
				shouldDirty: !1,
				shouldValidate: !0
			});
		});
	};
	return {
		buildAllSyncLists: () => a(s),
		updateMeasurementInSyncLists: (t) => {
			let { connections: n, analyticsSettings: r, syncDestinations: a } = o(), s = t.syncDest || [];
			a.forEach((t, a) => {
				if (s.includes(t.destinationId)) {
					let o = e({
						connections: n,
						analyticsSettings: r,
						destination: t
					});
					i(`syncSettings.syncDestinations.${a}.retentionMeasurementSyncInfo`, o, {
						shouldDirty: !1,
						shouldValidate: !0
					});
				}
			});
		},
		updateAnalyticsMeasurementsInSyncLists: (t) => {
			let { connections: n, analyticsSettings: r, syncDestinations: a } = o(), s = t ? {
				...r,
				...t
			} : r, c = /* @__PURE__ */ new Set();
			n.forEach((e) => {
				e.measurements?.forEach((e) => {
					e.analytics && e.sync && e.syncDest?.forEach((e) => {
						c.add(e);
					});
				});
			}), a.forEach((t, r) => {
				if (c.has(t.destinationId)) {
					let a = e({
						connections: n,
						analyticsSettings: s,
						destination: t
					});
					i(`syncSettings.syncDestinations.${r}.retentionMeasurementSyncInfo`, a, {
						shouldDirty: !1,
						shouldValidate: !0
					});
				}
			});
		}
	};
};
//#endregion
export { r as t };

//# sourceMappingURL=useBuildSyncLists-BAwVcEtd.js.map